var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6976 0.0779145C13.4242 -0.0525087 13.102 -0.0179387 12.8663 0.172196L5.22321 6.28637H1.57136C0.705542 6.28637 0 6.99191 0 7.85773V14.1432C0 15.0106 0.705542 15.7145 1.57136 15.7145H5.22321L12.8647 21.8287C13.0077 21.9419 13.1822 22 13.3566 22C13.4729 22 13.5891 21.9733 13.6976 21.9214C13.9694 21.791 14.1423 21.516 14.1423 21.2143V0.786599C14.1423 0.484898 13.9694 0.209909 13.6976 0.0779145Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1191 5.44485C17.8096 5.14 17.313 5.14472 17.0082 5.45113C16.7033 5.76069 16.7065 6.25724 17.0145 6.56366C18.2024 7.7359 18.8561 9.31197 18.8561 11.0012C18.8561 12.6904 18.2024 14.2665 17.0145 15.4387C16.7065 15.742 16.7033 16.2401 17.0082 16.5497C17.1622 16.7052 17.3649 16.7822 17.566 16.7822C17.7656 16.7822 17.9651 16.7068 18.1191 16.5544C19.6088 15.0883 20.4275 13.1147 20.4275 11.0012C20.4275 8.8877 19.6088 6.91407 18.1191 5.44485Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3367 3.23001C20.0272 2.92359 19.5306 2.92673 19.2242 3.23472C18.9193 3.54271 18.9225 4.04083 19.2289 4.34567C21.0155 6.1166 21.9992 8.47993 21.9992 11.0004C21.9992 13.5209 21.0155 15.8826 19.2289 17.6535C18.9225 17.96 18.9193 18.4581 19.2242 18.7661C19.3798 18.9201 19.5809 18.9971 19.782 18.9971C19.9816 18.9971 20.1827 18.9216 20.3367 18.7692C22.4235 16.7029 23.5706 13.9436 23.5706 11.0004C23.5706 8.05723 22.4235 5.29792 20.3367 3.23001Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.772ed5f9d690ed4d32477bd8e6036b6b.svg";
export { ForwardRef as ReactComponent };